import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Field from "./field";

class PasswordField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false
    };
  }

  toggle_show = () => {
    this.setState({ show: !this.state.show });
  };

  getShowIcon() {
    const onclick = () => this.toggle_show();
    const icon_id = "eye_icon";
    return this.state.show ?
      <FaEye id={icon_id} onClick={onclick}/> :
      <FaEyeSlash id={icon_id} onClick={onclick}/>;
  }

  getType() {
    return this.state.show ? "text" : "password";
  }

  render() {
    const icon_show = this.getShowIcon();
    const type = this.getType();
    const label = this.props.label || "Password";
    const id = this.props.id || "password";
    return (
      <div className="password">
        <Field className="password_field" id={id} label={label} value={this.props.password} handleChange={this.props.onChange} type={type}/>
        {icon_show}
      </div>
    );
  }
}

PasswordField.propTypes = {
  onChange: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired
};

export default PasswordField;